import { get } from 'lodash';

import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import type { PublicationItemAttributes } from 'hb-builder/components/BuilderComponents/dynamic/Publication/types';
import { SelectWrapper } from 'hb-builder/components/common/SettingsLibrary/CommonSettings/styles/SelectWrapper';
import type { Option } from 'hb-builder/utils/dynamicSelectorsHelpers';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

const DATA_TYPE_SETTING_KEY = 'dynamicAttributes.query.dataType';

export interface TypeOfFillSelectSettingProps {
  disabled: boolean;
  onChange: (value: {
    id: string;
    settingKey: `attributes.dynamicAttributes.query.dataType`;
    value: string;
  }) => void;
  options: Option[];
  item: DocumentItem<PublicationItemAttributes>;
}

const TypeOfFillSelectSetting = ({
  disabled,
  item,
  options,
  onChange,
}: TypeOfFillSelectSettingProps) => {
  const handleChange = ({ value }: { value: string }) => {
    onChange({
      id: item.id,
      settingKey: `attributes.${DATA_TYPE_SETTING_KEY}`,
      value,
    });
  };

  const computedValue = get(item.attributes, DATA_TYPE_SETTING_KEY, '');
  const valueSelected = getReactSelectValue(options, computedValue);

  return (
    <SelectWrapper data-testid="select-publication">
      <ReactSelectInput
        ariaDescribedBy="fill-type"
        ariaLabel={s__('Builder|How do you want to fill your publication ?')}
        disabled={disabled}
        id="settingsSelect"
        label={s__('Builder|How do you want to fill your publication ?')}
        name="settingsSelect"
        onChange={handleChange}
        options={options}
        placeholder={valueSelected?.label}
        value={valueSelected}
        width="100%"
      />
    </SelectWrapper>
  );
};

export default TypeOfFillSelectSetting;
